import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { BUTTON_BG_COLOR, BUTTON_COLOR, BUTTON_HOVER_BG_COLOR } = constants;

let styles = {
  base: {
    fontSize: 28,
    zIndex: 1,
    backgroundColor: BUTTON_BG_COLOR,
    color: BUTTON_COLOR,
    borderRadius: 200,
    padding: '6px 15px',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: BUTTON_HOVER_BG_COLOR
    }
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/inputs/addbutton/AddButton.styles.js